import { RedemptionCode } from '../models/UserStore/Invitation';

type GiftCardConfig = {
  diamond?: number;
  creationToken?: number;
  token?: number;
  value: string;
  desc: string;
};

const giftCardConfigs: GiftCardConfig[] = [
  {
    diamond: 28,
    creationToken: 15,
    value: 'USD20.98',
    desc: '* Use Creation Tokens to create AI Gamified Posts, AI JOY Chess and AI Memory Games!',
  },
  {
    diamond: 80,
    value: 'USD49.99',
    desc: '* Remarks: Use Diamonds to redeem a ticket to enter Quarterly Final of WEA Contests.',
  },
  {
    diamond: 80,
    creationToken: 15,
    value: 'USD50.98',
    desc: '* Use Creation Tokens to create AI Gamified Posts, AI JOY Chess and AI Memory Games!',
  },
  {
    diamond: 180,
    creationToken: 15,
    value: 'USD100.98',
    desc: '* Use Creation Tokens to create AI Gamified Posts, AI JOY Chess and AI Memory Games!',
  },
  {
    creationToken: 360,
    token: 750,
    value: 'USD39.98',
    desc: '* Use Creation Tokens to create AI Gamified Posts, AI JOY Chess and AI Memory Games!',
  },
  {
    creationToken: 30,
    diamond: 80,
    token: 30,
    value: 'USD52.96',
    desc: '* Use Creation Tokens to create AI Gamified Posts, AI JOY Chess and AI Memory Games!',
  },
];
export const getGiftCardValue = (
  redemptionCode: RedemptionCode | null | undefined,
): { value: string; desc: string } | undefined => {
  if (!redemptionCode) return undefined;
  const foundConfig = giftCardConfigs.find(
    (config) =>
      config.diamond === redemptionCode.reward.diamond &&
      config.creationToken === redemptionCode.reward.creationToken &&
      config.token === redemptionCode.reward.token,
  );
  return foundConfig
    ? { value: foundConfig.value, desc: foundConfig.desc }
    : undefined;
};
